export default "__VITE_ASSET__BkA$c1Jq__"